import { render, staticRenderFns } from "./SelectionBar.vue?vue&type=template&id=f2d1048c&scoped=true&"
import script from "./SelectionBar.vue?vue&type=script&lang=js&"
export * from "./SelectionBar.vue?vue&type=script&lang=js&"
import style0 from "./SelectionBar.vue?vue&type=style&index=0&id=f2d1048c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d1048c",
  null
  
)

export default component.exports